import axiosInstance from "src/utils/axios-instance";

import { actionCreator, createRequestTypes } from '../utils/helpers';


export const GET_LINKED_ACCOUNTS_BY_ACCOUNTID = createRequestTypes('GET_LINKED_ACCOUNTS_BY_ACCOUNTID');
export const GET_LINKED_ACCOUNTS_BY_USERID = createRequestTypes('GET_LINKED_ACCOUNTS_BY_USERID');
export const LINK_ACCOUNT = createRequestTypes('LINK_ACCOUNT');
export const UNLINK_ACCOUNT = createRequestTypes('UNLINK_ACCOUNT');








export const getLinkedAccounts = (accountId) => {
  return async dispatch => {
    dispatch(actionCreator.request(GET_LINKED_ACCOUNTS_BY_ACCOUNTID));
    try {
      const response = await axiosInstance.get(`linked-accounts/by-account/${accountId}`);
      dispatch(actionCreator.success(GET_LINKED_ACCOUNTS_BY_ACCOUNTID, response.data));
      return response.data
    } catch (error) {
      dispatch(actionCreator.failure(GET_LINKED_ACCOUNTS_BY_ACCOUNTID, error.response));
    }
  }
}

export const getLinkedAccountsUserId =  (userId) => {
  return async dispatch => {
    dispatch(actionCreator.request(GET_LINKED_ACCOUNTS_BY_USERID));
    try {
      const response = await axiosInstance.get(`linked-accounts/by-user/${userId}`);
      dispatch(actionCreator.success(GET_LINKED_ACCOUNTS_BY_USERID, response.data));
      return response.data
    } catch (error) {
      dispatch(actionCreator.failure(GET_LINKED_ACCOUNTS_BY_USERID, error.response));
    }
  }
}

export const linkAccount = (payload, linkedUsers) => {

  return dispatch => {
    return axiosInstance.get(`linked-accounts/by-account/${payload.accountId}`).then((res) => {
      const isUserLinked = linkedUsers.some(user =>
        res.data.linkedAccountList.some(account => account.accountInfo.accountId === user.accountInfo.accountId)
      );
      if(isUserLinked) {
        return { message: 'User already exists' };
      } else {
        return axiosInstance.post(`linked-accounts/link-user-to-account`, payload)
          .then(response => {
            dispatch(actionCreator.success(LINK_ACCOUNT, response.data));
            return response.data;
          })
          .catch(error => {
            dispatch(actionCreator.failure(LINK_ACCOUNT, error.response));
            return error.response;
          });
      }
      //return res.data
    })
      .catch(error => {
        return error
      })

  }
}

export const unLinkAccount = (payload) => {
  return dispatch => {
    return axiosInstance.post(`linked-accounts/unlink-user-from-account`, payload)
      .then(response => {
        dispatch(actionCreator.success(UNLINK_ACCOUNT, response.data));
        return response.data;
      })
      .catch(error => {
        dispatch(actionCreator.failure(UNLINK_ACCOUNT, error.response));
        return error.response;
      });
  }
}